"use client";

import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { IBlocks, IUserData } from "@/types";
import { Separator } from "@/components/ui/separator";
import React from "react";
import { replaceProtocolWithHTTPS, startsWithHTTPS } from "@/lib/utils";
import { toast } from "sonner";
import CardSetting from "@/components/admin/settings/CardSetting";
import { Label } from "@/components/ui/label";
import {
    IconCirclesRelation,
    IconDotsVertical,
    IconFile,
    IconLayoutGrid,
    IconQuestionMark,
} from "@tabler/icons-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import LinkSelectorDropdown from "../LinkSelectorDropdown";
interface Props {
    account: IUserData;
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}
export default function LinkOptions({
    account,
    block,
    blockUpdate,
    update,
}: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    const [url, setUrl] = React.useState(block.url);
    const [name, setName] = React.useState(block.name);
    const linkSelect = (_url: string) => {
        if (oldBlock.url != _url) {
            setUrl(_url);
            update({
                ...block,
                url: _url,
            });
            setOldBlock({
                ...oldBlock,
                url: _url,
            });
        }
    };
    return (
        <div className="flex w-full flex-col gap-3">
            <CardSetting title="General" noBorder>
                <div className="flex w-full flex-col gap-3">
                    <Input
                        label="Title"
                        placeholder="My Block"
                        variant="card"
                        className="w-full"
                        required
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value);
                            blockUpdate({
                                ...block,
                                name: e.target.value,
                            });
                        }}
                        onBlur={(e) => {
                            if (oldBlock.name != e.target.value) {
                                update({
                                    ...block,
                                    name: e.target.value,
                                });
                                setOldBlock({
                                    ...oldBlock,
                                    name: e.target.value,
                                });
                            }
                        }}
                    />
                    <div className="flex items-end gap-1">
                        <Input
                            label="URL"
                            variant="card"
                            className="w-full"
                            placeholder="https://doras.to"
                            required
                            value={url}
                            onChange={(e) => {
                                setUrl(e.target.value);
                                blockUpdate({
                                    ...block,
                                    url: e.target.value,
                                });
                            }}
                            onBlur={(e) => {
                                if (!startsWithHTTPS(e.target.value)) {
                                    e.target.value = replaceProtocolWithHTTPS(
                                        e.target.value
                                    );
                                    setUrl(e.target.value);
                                    blockUpdate({
                                        ...block,
                                        url: e.target.value,
                                    });
                                }
                                if (oldBlock.url != e.target.value) {
                                    update({
                                        ...block,
                                        url: e.target.value,
                                    });
                                    setOldBlock({
                                        ...oldBlock,
                                        url: e.target.value,
                                    });
                                }
                            }}
                        />
                        <LinkSelectorDropdown
                            account={account}
                            linkSelect={linkSelect}
                        />
                    </div>
                    <Separator />
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <Label variant="toggle">NSFW Warning</Label>
                            <Popover>
                                <PopoverTrigger asChild>
                                    <div className="cursor-pointer rounded-md bg-accent p-1">
                                        <IconQuestionMark
                                            size={14}
                                            className=""
                                        />
                                    </div>
                                </PopoverTrigger>
                                <PopoverContent className="z-[9999] space-y-2 p-1">
                                    <Label variant={"subtoggle"}>
                                        Provides context if this link goes to
                                        mature and/or NSFW content. It will
                                        prompt a warning to the user before they
                                        click on the link.
                                    </Label>
                                    <Label variant={"subtoggle"}>
                                        Depending on the link provided, we may
                                        automatically add this warning which
                                        cannot be removed.
                                    </Label>
                                </PopoverContent>
                            </Popover>
                        </div>
                        <Switch
                            onCheckedChange={(checked) =>
                                update({
                                    ...block,
                                    adult: checked,
                                })
                            }
                            checked={block.adult}
                        />
                    </div>
                </div>
            </CardSetting>
        </div>
    );
}
